<img class="page-image align-center" [src]="bookService.getPageAtOffset(1)">
<div class="click-it align-center" [style.width]="metricsService.singleModePageWdith+'px'" 
  (swiperight)="handleLeftSideGesture()" (swipeleft)="handleRightSideGesture()" >
  <div class="page-button hand" (click)="handleLeftSideGesture()" ></div>
  <div class="page-button zoom" (click)="openFullspaceView()"></div>
  <div class="page-button  hand" (click)="handleRightSideGesture()"></div>
</div>
